export default class EmailItem {
    constructor(content, isRead = false) {
        this.content = content;
        this.isRead = isRead;
    }
}